
import React from "react";
import SearchResults from "./SearchResults";
import SearchContainer from "../containers/SearchContainer";
import Favoritter from "./Favoritter";
import SisteHunder from "./SisteHunder";
import MineHunder from "./MineHunder";


const Forside = ({favoritter, mineHunder, sisteHunder}) => {

    return (
        <div className="dogweb-box frontpage-box">
            <SearchContainer hideToolbarOnSearch={true}>
                { props => (
                    <SearchResults {...props} />
                )}
            </SearchContainer>
            <ul className="doglinks-list">
                <Favoritter hunder={favoritter} />
                <MineHunder hunder={mineHunder} />
                <SisteHunder hunder={sisteHunder} />
            </ul>


        </div>
    );

};
export default Forside;